const question5 = {
    'question': 'Czy psycholog wesprze moje dziecko w trakcie rozwodu?',
    'answer': 'Tak, psycholog może zapewnić wsparcie Twojemu dziecku w trakcie rozwodu. Psycholog może pomóc dziecku w: zrozumieniu sytuacji rozwodu, radzeniu sobie z emocjami i utrzymaniu kontaktu z obojgiem rodziców. Jeśli uważasz, że Twoje dziecko może potrzebować wsparcia psychologicznego w trakcie rozwodu, warto rozważyć konsultację z psychologiem.',
}

export default question5;